import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function ComparisonTable() {
  const comparisons = [{
    scenario: 'La ansiedad te toma por sorpresa',
    sin: 'Esperás a que pase sola',
    con: 'Protocolo de 60 segundos. Estado regulado en el momento.'
  }, {
    scenario: 'Necesitás cerrar una venta hoy',
    sin: 'No sabés qué decir ni cómo decirlo',
    con: 'Script listo. Patrón lingüístico de PNL aplicado.'
  }, {
    scenario: 'El entorno tóxico te drena',
    sin: 'Absorbés la energía ajena sin querer',
    con: 'Técnica del escudo de vidrio. Blindaje activo.'
  }, {
    scenario: 'Noche de pensamientos que no paran',
    sin: 'Celular hasta las 2am sin dormir bien',
    con: 'Protocolo de hackeo del sueño. Reprogramás mientras dormís.'
  }, {
    scenario: 'Un día donde no podés con nada',
    sin: 'Parálisis total o abandono del proceso',
    con: 'Método One-Shot. Una acción. Momentum activado.'
  }, {
    scenario: 'Alguien te ataca o te minimiza',
    sin: 'Te quedás sin palabras o reaccionás mal',
    con: '40 respuestas soberanas listas para usar en el momento.'
  }];
  return <section className="py-20 px-4 bg-dark-card/30" data-id="element-41">
      <div className="max-w-5xl mx-auto" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-43">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4" data-id="element-44">
            ¿QUÉ AGREGA EL PROTOCOLO DE EMERGENCIA?
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-45">
          {comparisons.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark border border-dark-border rounded-xl overflow-hidden flex flex-col md:flex-row" data-id="element-46">
              <div className="p-6 md:w-1/3 bg-dark-lighter border-b md:border-b-0 md:border-r border-dark-border flex items-center" data-id="element-47">
                <h4 className="font-bold text-white text-lg" data-id="element-48">
                  {item.scenario}
                </h4>
              </div>

              <div className="flex flex-col md:flex-row md:w-2/3" data-id="element-49">
                <div className="p-6 md:w-1/2 border-b md:border-b-0 md:border-r border-dark-border/50 flex flex-col gap-3" data-id="element-50">
                  <div className="flex items-center gap-2 text-red-400 text-sm font-bold tracking-wider" data-id="element-51">
                    <X className="w-4 h-4" data-id="element-52" /> SIN PROTOCOLO
                  </div>
                  <p className="text-gray-400" data-id="element-53">{item.sin}</p>
                </div>

                <div className="p-6 md:w-1/2 bg-gold/5 flex flex-col gap-3" data-id="element-54">
                  <div className="flex items-center gap-2 text-green-400 text-sm font-bold tracking-wider" data-id="element-55">
                    <Check className="w-4 h-4" data-id="element-56" /> CON PROTOCOLO
                  </div>
                  <p className="text-white font-medium" data-id="element-57">{item.con}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}